import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  year: number;
  rating: number;
  image: string;
  isNew?: boolean;
  hot?: boolean;
}

export default function MovieCard({ id, title, categoryName, year, rating, image, isNew, hot }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={image}
          alt={`${title} 电影海报`}
          title={`${title} - 嫩草影院高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        {isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-background-50 whitespace-nowrap">
            NEW
          </span>
        )}
        {hot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-950 whitespace-nowrap">
            热门
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <div className="flex items-center justify-center">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950">
              <i className="ri-play-fill text-lg"></i>
            </div>
          </div>
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-1.5 py-0.5 rounded text-xs font-bold bg-background-950/70 text-primary-400 whitespace-nowrap">
            {rating}
          </span>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{year}</span>
          <span className="text-xs text-foreground-600">·</span>
          <span className="text-xs text-foreground-500">{categoryName}</span>
        </div>
      </div>
    </Link>
  );
}